// Import dependencies
import React from 'react';
import cookie from 'js-cookie';
import queryString from 'query-string';
import axios from 'axios';

// Import components
import LoadingSpinner from '../../../reusables/spinner';

// Import configuration from .json file
import config from '../../../../configs/config.json';
const AUTH_URL = config.AUTH_URL;

class VerifyEmailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            memberId: '',
            verificationCode: '',
            status: {
                previouslyActivated: false,
                codeExpired: false,
                codeInvalid: false,
            },
            loading: true,
            error: false
        }
    }

    componentDidMount() {
        // When the component (screen) mounts, check cooke if user is already logged in

        var token = cookie.get('token');
        var user_type = cookie.get('user-type');

        if (token) {
            if (user_type === 'member') {
                // If user logged in is a member, re-direct them to the videos menu
                window.location.href = '/videos';
            } else if (user_type === 'admin') {
                // IF user logged in is an admin, re-direct them to the login history page
                window.location.href = '/admin/history';
            }
        }


        // Obtain query parameters from URL
        var { code, mid } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });

        // If there is no code or member id specified in the query parameters,
        // the user has no business being here, re-direct them to the home page
        if (!code || !mid) {
            window.location.href = '/';
        }

        // Make a request to the back-end to verify email with code and member id
        axios.post(`${AUTH_URL}/verify?id=${mid}&code=${code}`)
            .then(response => {
                // Save the response from back-end into state
                // console.log(response.data);
                var status = this.state.status;
                status.previouslyActivated = (response.data.previouslyActivated) ? response.data.previouslyActivated : false;
                status.codeExpired = (response.data.codeExpired) ? response.data.codeExpired : false;
                status.codeInvalid = (response.data.codeInvalid) ? response.data.codeInvalid : false;

                this.setState({ loading: false, status: status });
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false, error: true });
            })
    }



    render() {
        if (this.state.error) {
            return (
                <div className='container'>
                    <div className="alert alert-danger">
                        Server error, try again!
                    </div>
                </div>
            );
        }
        else if (this.state.loading) {
            return (
                <LoadingSpinner message='Verifying email, please wait..' />
            );
        } else if (this.state.status.previouslyActivated) {
            return (
                <div className='container'>
                    <div className='alert alert-success'>
                        You're account has already been activated.<br />
                        Click <a href='/login'>here</a> to log in.
                    </div>
                </div>
            )
        } else if (this.state.status.codeExpired) {
            return (
                <div className='container'>
                    <div className='alert alert-danger'>
                        This email verification link has expired. <br />
                        Contact OLLI @ UCI to generate a new link.
                    </div>
                </div>
            )
        } else if (this.state.status.codeInvalid) {
            return (
                <div className='container'>
                    <div className='alert alert-danger'>
                        This activation link is invalid. Please click the link from the most recent email from us.
                    </div>
                </div>
            )
        } else {
            return (
                <div className='container'>
                    <div className='alert alert-success'>
                        You're account has been successfully activated.<br />
                        Click <a href='/login'>here</a> to log in.
                    </div>
                </div>
            )
        }
    }
}

export default VerifyEmailPage;